import { useEffect, useState } from 'react';

const sizes = new Map([
  ['mobile', '(max-width: 767px)'],
  ['tablet', '(max-width: 1110px)'],
  ['desktop', '(min-width: 1110px)'],
]);

const useMediaQuery = (size) => {
  const [matches, setMatches] = useState(null);

  useEffect(() => {
    const updateMatches = () => {
      const query = sizes.get(size) || `(max-width: ${size}px)`;
      setMatches(window.matchMedia(query).matches);
    };

    updateMatches();

    window.addEventListener('resize', updateMatches);
    return () => window.removeEventListener('resize', updateMatches);
  }, []);

  return matches;
};

export default useMediaQuery;
